import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Stack, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useCallback, useEffect, useState } from 'react';
import { useRef } from 'react';
import { dropdownFetch } from '../../../../../utils';

export const GeneralDetailForm = ({ onAdd, onClose }) => {
    const [doctordropdown, setDoctordropdown] = useState([])
    const getDoctorDropdown = useCallback(async () => {
        const data = await dropdownFetch('doctor');
        console.log("HELLOOOOO DATA", data)
        setDoctordropdown(data);
    }, []);

    useEffect(() => {
        getDoctorDropdown()
    }, getDoctorDropdown)
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                patient_name: Yup.string().required(' '),
                doctor: Yup.string().required(' ')
            })
        ),
        mode: 'all'
    });
    const { handleSubmit, reset } = methods;
    const bedNoRef = useRef();


    const formSubmit = (formValue) => {
        // Find the full doctor object using the _id from formValue
        const selectedDoctor = doctordropdown.find(doc => doc._id === formValue.doctor);
        // Combine the formValue with the full doctor bject
        const fullFormValue = {
            ...formValue,
            doctor: {
                _id: selectedDoctor._id,
                name: selectedDoctor.name,
            }
        };
        // Pass the full form data with doctor details to the parent component
        onAdd(fullFormValue);
        console.log("Form Submitted with Doctor Details:", fullFormValue);
        reset();
        if (bedNoRef.current) {
            bedNoRef.current.focus();
        }
    };
    useEffect(() => {
        if (bedNoRef.current) {
            bedNoRef.current.focus();
        }
    }, []);
    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Typography color="primary" variant="h6" sx={{ fontWeight: 600 }}>
                Patient Detail Form
            </Typography>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
                <Typography sx={{ flex: 0.4 }}>Patient Name</Typography>
                <TextField sx={{ flex: 0.6 }} name="patient_name" placeholder="Enter Patient Name" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
                <Typography sx={{ flex: 0.4 }}>Doctor</Typography>
                <SelectTag
                    formControlSX={{ flex: 0.6 }}
                    name="doctor"
                    menus={doctordropdown}
                    placeholder="Doctor"
                />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit">
                    Add
                </Button>
                <Button color="error" onClick={onClose}>
                    Close
                </Button>
            </Stack>
        </FormProvider>
    );
};
